import { Box } from '@hivebrite/design-system/Box';
import { ContentList } from '@hivebrite/design-system/ContentList';
import type {
  PerContentListProps,
  CONTENT_TYPES,
} from '@hivebrite/design-system/ContentList';
import { Divider } from '@hivebrite/design-system/Divider';

import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { RecommendedContentCardSkeleton } from 'hb-react/shared/components/ContentRecommendation/components/RecommendedContentCardSkeleton';
import { useGetRecommendedContents } from 'hb-react/shared/components/ContentRecommendation/hooks/useGetRecommendedContents';
import type { AvailableContentTypes } from 'hb-react/shared/components/ContentRecommendation/types';

interface ContentRecommendationProps {
  contentId: number;
  contentType: AvailableContentTypes;
  recommendedContentTypes: Array<AvailableContentTypes>;
}

export const ContentRecommendation = ({
  contentId,
  contentType,
  recommendedContentTypes,
}: ContentRecommendationProps) => {
  const { topicId: groupId } = useTopicContext();

  const { data: contentItems, isLoading } = useGetRecommendedContents({
    contentId,
    contentType,
    groupId,
    recommendedContentTypes,
  });

  if (!isLoading && contentItems.length === 0) {
    return null;
  }

  return (
    <Box mb={6} flexDirection="column">
      <Divider mb={8} />
      {isLoading && contentItems.length === 0 ? (
        Array.from({ length: 3 }).map((_, index) => (
          <RecommendedContentCardSkeleton key={index} />
        ))
      ) : (
        <ContentList
          data={contentItems as Array<PerContentListProps[CONTENT_TYPES]>}
          listTitle={s__('ContentRecommendation|You may be interested in')}
          isCardClickable
          isListInsideCard={false}
          isLoading={isLoading}
          max={3}
        />
      )}
    </Box>
  );
};
